<template>
  <span>
    <div v-if="this.params.isReadOnly">
      {{ params.statusByValue(params.data.learnerStatus).text }}
    </div>
    <div v-else>
      <select v-model="selection" class="mt-1 p-1 rounded-1">
        <option
          v-for="s in params.learnerStatuses.statuses"
          :key="s.value"
          :value="s.value"
          >{{ s.text }}</option
        >
      </select>
    </div>
  </span>
</template>

<script lang="js">
import Vue from 'vue'

export default Vue.extend({
  data: function () {
    return {
      selection: null,
    }
  },
  mounted() {
    this.selection = this.params.data.learnerStatus || 0
  },
  watch: {
    selection(newValue, oldValue) {
      if (newValue != oldValue && oldValue != null) {
        this.params.data.learnerStatus = newValue
        this.params.onSelectionChangedCallback(this.params.node, newValue)
      }
    }
  }
})

</script>